module.exports = __webpack_public_path__ + "img/building-blue.47a5cff8.png";